const popup = () => {
	// Newsletter popup
	jQuery(function($) {
		var body = $('body')
		var popup = $('.newsletter')
		var popupContainer = $('.newsletter__container')
		var buttonOpen = $('.openNewsletter')
		var buttonClose = $('.closeNewsletter')
		var tl = new TimelineLite()

		buttonOpen.click(() => openModal())

		buttonClose.click(() => closeModal())

		// Close modal if click ousite the modal
		popup.on('click', function(e) {
			if (popup.has(e.target).length === 0) {
				closeModal()
			}
		})

		// Form logic
		$('#sb_form input[type="radio"]').on('click', function() {
			$('#input-7q5kzcf0lgklyxmd1qn1s').val($(this).val())
		})

		function closeModal() {
			tl.to(popupContainer, 0.4, {
				y: '-1000px',
				opacity: 0,
			})
			tl.to(popup, 0.4, {
				scale: 0,
				opacity: 0,
				delay: 0.4,
			})
			body.removeClass('nav-active')
		}

		function openModal() {
			tl.to(popup, 0.4, {
				scale: 1,
				opacity: 1,
			})
			tl.to(popupContainer, 0.8, {
				opacity: 1,
				y: 0,
				delay: 0.4,
			})
			body.addClass('nav-active')
		}
	})

	// Video popup
	jQuery(function($) {
		var body = $('body')
		var popup = $('#videoModal')
		var popupContainer = $('#videoModal_container')
		var buttonOpen = $('.openvideoModal')
		var buttonClose = $('.closevideoModal')
		var tl = new TimelineLite()

		buttonOpen.click(() => openModal())

		buttonClose.click(() => closeModal())

		// Close modal if click ousite the modal
		popup.on('click', function(e) {
			if (popup.has(e.target).length === 0) {
				closeModal()
			}
		})

		// Form logic
		$('#sb_form input[type="radio"]').on('click', function() {
			$('#input-7q5kzcf0lgklyxmd1qn1s').val($(this).val())
		})

		function closeModal() {
			tl.to(popupContainer, 0.4, {
				y: '-1000px',
				opacity: 0,
			})
			tl.to(popup, 0.4, {
				scale: 0,
				opacity: 0,
				delay: 0.4,
			})
			body.removeClass('nav-active')
		}

		function openModal() {
			tl.to(popup, 0.4, {
				scale: 1,
				opacity: 1,
			})
			tl.to(popupContainer, 0.8, {
				opacity: 1,
				y: 0,
				delay: 0.4,
			})
			body.addClass('nav-active')
		}
	})

	// Labels popup
	jQuery(function() {
		var tl = new TimelineLite()
		var body = $('body')

		var modalBtns = [...document.querySelectorAll('.openLabelsModal')]
		modalBtns.forEach(function(btn) {
			btn.onclick = function() {
				event.preventDefault()
				var modal = btn.getAttribute('data-modal')
				tl.to(document.getElementById(modal), 0.4, {
					scale: 1,
					opacity: 1,
				})
				tl.to(
					document
						.getElementById(modal)
						.getElementsByClassName('labels__modal-container'),
					0.8,
					{
						opacity: 1,
						y: 0,
						delay: 0.4,
					}
				)
				body.addClass('nav-active')
			}
		})

		var closeBtns = [...document.querySelectorAll('.closeLabelsModal')]
		closeBtns.forEach(function(btn) {
			btn.onclick = function() {
				event.preventDefault()
				var modal = btn.closest('.labelsModal')
				tl.to(modal.getElementsByClassName('labels__modal-container'), 0.4, {
					y: '-1000px',
					opacity: 0,
				})
				tl.to(modal, 0.4, {
					scale: 0,
					opacity: 0,
					delay: 0.4,
				})
				body.removeClass('nav-active')
			}
		})
	})

	// Conso energetique popup
	jQuery(function($) {
		var popup = $('.ges')
		var popupContainer = $('.ges__container')
		var buttonOpen = $('.ges__open')
		var buttonClose = $('.ges__close')
		var tl = new TimelineLite()

		buttonOpen.click(function(event) {
			event.preventDefault()
			openModal()
			let imgName = $(this).attr('data-img')
			let top = $(this).attr('data-top')
			let note = $(this).attr('data-note')

			popupContainer.find('.ges__note').css('top', top + '%')
			popupContainer.find('.ges__c img').attr('src', imgName)
			popupContainer.find('.ges__note').text(note)
		})

		buttonClose.click(() => closeModal())

		// Close modal if click ousite the modal
		popup.on('click', function(e) {
			if (popup.has(e.target).length === 0) {
				closeModal()
			}
		})

		function closeModal() {
			tl.to(popupContainer, 0.4, {
				y: '-1000px',
				opacity: 0,
			})
			tl.to(popup, 0.4, {
				scale: 0,
				opacity: 0,
				delay: 0.4,
			})
		}

		function openModal() {
			tl.to(popup, 0.4, {
				scale: 1,
				opacity: 1,
			})
			tl.to(popupContainer, 0.8, {
				opacity: 1,
				y: 0,
				delay: 0.4,
			})
		}
	})

	// Open financial product popup
	jQuery(function($) {
		var body = $('body')
		var popup = $('.fin')
		var popupContainer = $('.fin__container')
		var tl = new TimelineLite()

		body.on('click', '.fin__open', function() {
			const title = $(this)
				.find('.offers__title')
				.text()
			const post_id = $(this).attr('data-id')
			const objectBase = popup.find('.js-object').text()
			const object = `${objectBase.trim()} ${title.trim()}`

			$.post(
				ajaxurl,
				{
					action: 'zz_get_modal_fin',
					post_id: post_id,
				},
				res => {
					// Clean old
					popup
						.find('.fin__modal--content-ajax')
						.find('*')
						.remove()
					// // append results
					popup.find('.fin__modal--content-ajax').append(res)
				}
			)

			openModal()

			popup.find('form input#objet').val(object)
		})

		body.on('click', '.fin__close', function() {
			closeModal()
		})

		// Close modal if click ousite the modal
		popup.on('click', function(e) {
			if (popup.has(e.target).length === 0) {
				closeModal()
			}
		})

		function closeModal() {
			tl.to(popupContainer, 0.4, {
				y: '-1000px',
				opacity: 0,
			})
			tl.to(popup, 0.4, {
				scale: 0,
				opacity: 0,
				delay: 0.4,
			})
		}

		function openModal() {
			tl.to(popup, 0.4, {
				scale: 1,
				opacity: 1,
			})
			tl.to(popupContainer, 0.8, {
				opacity: 1,
				y: 0,
				delay: 0.4,
			})
		}
	})

	// Mentions legales popup
	jQuery(function($) {
		var body = $('body')
		var popup = $('.mlModal')
		var popupContainer = $('.mlModal__container')
		var buttonOpen = $('.openMlModal')
		var buttonClose = $('.closeMlModal')
		var tl = new TimelineLite()

		buttonOpen.click(function(e) {
			e.preventDefault()
			openModal()
		})

		buttonClose.click(function(e) {
			e.preventDefault()
			closeModal()
		})

		// Close modal if click ousite the modal
		popup.on('click', function(e) {
			e.preventDefault()
			if (popup.has(e.target).length === 0) {
				closeModal()
			}
		})

		function closeModal() {
			tl.to(popupContainer, 0.4, {
				y: '-1000px',
				opacity: 0,
			})
			tl.to(popup, 0.4, {
				scale: 0,
				opacity: 0,
				delay: 0.4,
			})
			body.removeClass('nav-active')
		}

		function openModal() {
			tl.to(popup, 0.4, {
				scale: 1,
				opacity: 1,
			})
			tl.to(popupContainer, 0.8, {
				opacity: 1,
				y: 0,
				delay: 0.4,
			})
			body.addClass('nav-active')
		}
	})
}

export { popup }
